import { schemas } from "@card-data/generated/api.client";

import { CreditCardInput } from "../types";

export const PNC_CARDS: Array<CreditCardInput> = [
  {
    cardId: "dfaa58e5c67e69cb711960cfd4567f9c",
    name: "Cash Rewards Visa Signature Business",
    issuer: schemas.IssuersEnum.enum.PNC,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: true,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://www.pnc.com/en/small-business/borrowing/business-credit-cards/pnc-cash-rewards-visa-signature-business-credit-card.html",
    imageUrl: "/images/pnc/cash-rewards-visa-signature-business.webp",
    credits: [],
    offers: [
      // technically has an elevated cashback rate for the first year, but nothing that's an actual offer
    ],
    historicalOffers: [
      {
        amount: [{ amount: 600 }],
        spend: 6000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "55ca66661e1048237628036f649733d7",
    name: "Cash Rewards Visa",
    issuer: schemas.IssuersEnum.enum.PNC,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.pnc.com/en/personal-banking/banking/credit-cards/pnc-cash-rewards-visa-credit-card.html",
    imageUrl: "/images/pnc/cash-rewards.jpg",
    details:
      "4% gas, 3% dining, 2% groceries (first $8k/yr combined bonus categories, then 1%).",
    credits: [],
    offers: [
      {
        amount: [{ amount: 200 }],
        spend: 1000,
        days: 90,
        credits: [],
        details: "$200 after $1,000 spend within first 3 billing cycles.",
      },
    ],
    historicalOffers: [],
  },
];
